const $ = require('jquery');
const cityAutocomplete = require('cityAutocomplete');
import get from 'lodash/get';

module.exports = {
  getLinkedTarget(id) {
    const linkedQid = parseInt(id);
    if (linkedQid == NaN) {
      return false;
    }
    return $(`[name*="answers[${linkedQid}]"]`);
  },
  handleLinkedQuestion(id) {
    const _this = this;
    const $target = _this.getLinkedTarget(id);
    if ($target.length) {
      $target.parents().filter('.questionsForm').find('.hide').removeClass('hide');
    }
  },
  handleSelectChange() {
    const _this = this;
    // .has-links klase norāda, ka atkarībā no dotā jautājuma atbildes, tiks/netiks rādīti papildus jautājumi.
    // pie katras atbildes, kam ir pielinkots jautājums ir norādīts data-linked-qid atribūts
    $('#QuestionsIndex select.has-links').on('change', function (e) {
      const $selectedOption = $(`select.has-links option[value="${$(this).val()}"]`);
      let ids = $selectedOption.data('linkedQid');
      if (ids) {
        if (typeof ids === 'string') {
          ids = ids.split(',');
        } else {
          ids = [ids];
        }
        ids.forEach((val) => {
          _this.handleLinkedQuestion(val);
        });
      } else {
        // ja ir izvēlēta atbilde, kam nav data-linked-qid, tad papildus jautājumi tiek slēpti.
        const $otherOptions = $selectedOption.siblings('option');
        $otherOptions.each(function () {
          let ids = $(this).data('linkedQid');
          if (!ids) {
            return true;
          }
          if (typeof ids === 'string') {
            ids = ids.split(',');
          } else {
            ids = [ids];
          }
          ids.forEach((val) => {
            const $target = _this.getLinkedTarget(val);
            if ($target.length) {
              $target.val('');
              $target.attr('checked', false);
              const $closestGridContainer = $target.parents().closest('.g-b');
              if ($closestGridContainer.hasClass('g-b--1of1')) {
                $closestGridContainer.parents().closest('.questionsForm-row').addClass('hide');
              } else {
                $closestGridContainer.addClass('hide');
              }
            }
          });
        });
      }
    });
  },
  getZodiacSignByDate(day, month) {
    const zod_signs = [
      '1016', // Mežāzis
      '1017', // Ūdensvīrs
      '1018', // Zivis
      '1007', // Auns
      '1008', // Vērsis
      '1009', // Dvīņi
      '1010', // Vēzis
      '1011', // Lauva
      '1012', // Jaunava
      '1013', // Svari
      '1014', // Skorpions
      '1015', // Strēlnieks
    ];

    let zodiacSign = '';
    switch (month) {
      case 1:
        {
          if (day < 20) {
            zodiacSign = zod_signs[0];
          } else {
            zodiacSign = zod_signs[1];
          }
        }
        break;
      case 2:
        {
          if (day < 19) {
            zodiacSign = zod_signs[1];
          } else {
            zodiacSign = zod_signs[2];
          }
        }
        break;
      case 3:
        {
          if (day < 21) {
            zodiacSign = zod_signs[2];
          } else {
            zodiacSign = zod_signs[3];
          }
        }
        break;
      case 4:
        {
          if (day < 20) {
            zodiacSign = zod_signs[3];
          } else {
            zodiacSign = zod_signs[4];
          }
        }
        break;
      case 5:
        {
          if (day < 21) {
            zodiacSign = zod_signs[4];
          } else {
            zodiacSign = zod_signs[5];
          }
        }
        break;
      case 6:
        {
          if (day < 21) {
            zodiacSign = zod_signs[5];
          } else {
            zodiacSign = zod_signs[6];
          }
        }
        break;
      case 7:
        {
          if (day < 23) {
            zodiacSign = zod_signs[6];
          } else {
            zodiacSign = zod_signs[7];
          }
        }
        break;
      case 8:
        {
          if (day < 23) {
            zodiacSign = zod_signs[7];
          } else {
            zodiacSign = zod_signs[8];
          }
        }
        break;
      case 9:
        {
          if (day < 23) {
            zodiacSign = zod_signs[8];
          } else {
            zodiacSign = zod_signs[9];
          }
        }
        break;
      case 10:
        {
          if (day < 23) {
            zodiacSign = zod_signs[9];
          } else {
            zodiacSign = zod_signs[10];
          }
        }
        break;
      case 11:
        {
          if (day < 22) {
            zodiacSign = zod_signs[10];
          } else {
            zodiacSign = zod_signs[11];
          }
        }
        break;
      case 12:
        {
          if (day < 22) {
            zodiacSign = zod_signs[11];
          } else {
            zodiacSign = zod_signs[0];
          }
        }
        break;
    }

    return zodiacSign;
  },
  handleProfileBirthDayMonthChange() {
    const _this = this;

    $('#QuestionsIndex #MembersProfileBirthDay, #QuestionsIndex #MembersProfileBirthMonth').on('change', (e) => {
      let day = $('#QuestionsIndex #MembersProfileBirthDay').val();
      let month = $('#QuestionsIndex #MembersProfileBirthMonth').val();

      $('#QuestionsIndex .zodiac_sign_error').remove();
      $('#QuestionsIndex #MembersAnswers111').closest('.form-group').removeClass('error');

      if (day == '' || month == '') {
        return false;
      }

      day = parseInt(day);
      month = parseInt(month);

      const zodiacSign = _this.getZodiacSignByDate(day, month);

      $('#QuestionsIndex #MembersAnswers111').val(zodiacSign);
    });
  },
  handleQuestion111Change() {
    const _this = this;

    $('#QuestionsIndex #MembersAnswers111').on('change', (e) => {
      // _this.checkProfileBirthDayZodiac();
    });
  },
  checkProfileBirthDayZodiac() {
    const _this = this;
    let day = $('#QuestionsIndex #MembersProfileBirthDay').val();
    let month = $('#QuestionsIndex #MembersProfileBirthMonth').val();

    $('#QuestionsIndex .zodiac_sign_error').remove();
    $('#QuestionsIndex #MembersAnswers111').closest('.form-group').removeClass('error');

    if (day == '' || month == '' || $('#QuestionsIndex #MembersAnswers111').val() == '') {
      return false;
    }

    day = parseInt(day);
    month = parseInt(month);

    const zodiacSign = _this.getZodiacSignByDate(day, month);

    if (zodiacSign != $('#QuestionsIndex #MembersAnswers111').val()) {
      $('#QuestionsIndex #MembersAnswers111').closest('.form-group').addClass('error').append(`<div class="error zodiac_sign_error ptxs"><div class="inner">${get(translations, 'txt: Horoskops ievadīts nekorekti', '')}</div></div>`);
    }
  },
  handleProfileBirthdayChange() {
      var _this = this;

      $('#QuestionsIndex #MembersProfileBirthDay, #QuestionsIndex #MembersProfileBirthMonth, #QuestionsIndex #MembersProfileBirthYear').on('change', (e) => {

          var day = $('#QuestionsIndex #MembersProfileBirthDay').val();
          var month = $('#QuestionsIndex #MembersProfileBirthMonth').val();
          var year = $('#QuestionsIndex #MembersProfileBirthYear').val();

          day = parseInt(day);
          month = parseInt(month);
          year = parseInt(year);

          var now = new Date();
          var nowDay = now.getDate();
          var nowMonth = now.getMonth() + 1;
          var nowYear = now.getFullYear();

          var age = nowYear - year;
          if (nowMonth < month || (nowMonth === month && nowDay < day)) {
              age -=1;
          }

          if (age < 18) {
              // Set red frame and add error message
              if ($('.not_18_error').length == 0) {
                  $('#QuestionsIndex #MembersProfileBirthDay').closest('.form-group').addClass('error').append('<div class="error not_18_error ptxs"><div class="inner">'+op.messages.not_18_error+'</div></div>');
              }
              // Disable continue button
              $('.questionsForm button').addClass('btn--disabled');
              $('#QuestionsIndex').submit(function(e) {
                  return false;
              });
          } else {
              // Make sure there is no birthday errors
              $('#QuestionsIndex #MembersProfileBirthDay').closest('.form-group').removeClass('error');
              $('.not_18_error').remove();
              // Make sure continue button is enabled
              $('.questionsForm button').removeClass('btn--disabled');
              $('#QuestionsIndex').unbind('submit');
          }
      });
  },
  init() {
    this.handleSelectChange();
    this.handleProfileBirthDayMonthChange();
    this.handleQuestion111Change();
    // this.checkProfileBirthDayZodiac();
    this.handleProfileBirthdayChange();
    $('input#MembersProfilePlaceIdAutocomplete').cityAutocomplete({ input_id: '#MembersProfilePlaceId' });
    const _this = this;
    $(document).on('pjax:end', () => {
      _this.handleSelectChange();
      _this.handleProfileBirthDayMonthChange();
      _this.handleQuestion111Change();
      // _this.checkProfileBirthDayZodiac();
      _this.handleProfileBirthdayChange();
      $('input#MembersProfilePlaceIdAutocomplete').cityAutocomplete({ input_id: '#MembersProfilePlaceId' });
      //
      if ($('#myProfileAnswerScoreNumber').length && $('.questionsProgress-score').length) {
        $('#myProfileAnswerScoreNumber').html($('.questionsProgress-score').html().replace('%', ''));
      }
    });
  },
};
